var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"src":_vm.filteredImageUrl}},[(_vm.loading)?_c('div',{staticClass:"d-flex align-center justify-center fill-height"},[_c('v-progress-circular',{attrs:{"color":"white","indeterminate":""}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }